// ============================================================
// services/fotocheckService.ts
// GET /matriculas/fotocheck con filtros opcionales en cascada.
// ============================================================

import { httpClient } from 'utils/httpClient';
import { FotocheckEstudiante, FotocheckFiltros } from 'types/fotocheck.types';

export const fotocheckService = {

  async listar(filtros: FotocheckFiltros, signal?: AbortSignal): Promise<FotocheckEstudiante[]> {
    const q = new URLSearchParams();
    q.set('anioEscolarId', String(filtros.anioEscolarId));
    if (filtros.nivel)        q.set('nivel',        filtros.nivel);
    if (filtros.gradoId)      q.set('gradoId',      String(filtros.gradoId));
    if (filtros.seccionId)    q.set('seccionId',    String(filtros.seccionId));
    if (filtros.estudianteId) q.set('estudianteId', String(filtros.estudianteId));

    const data = await httpClient.get<FotocheckEstudiante[]>(
      `/matriculas/fotocheck?${q}`,
      signal ? { signal } : undefined,
    );
    return Array.isArray(data) ? data : [];
  },
};
